<template>
  <ToggleSection label="Array Tomography Details" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[
        ['collection_substrate', 'sample_width'],
        ['amount_of_sections', 'tomography_section_thickness'],
        ['coating_material', 'coating_thickness'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'ArrayTomographyDetails',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
